module.exports = __webpack_public_path__ + "static/media/EnrichGoodOptimized.89257251.png";